import { withAsync } from 'view/common/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export default withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: "async-unified-help-home-page" */ 'unified-help-center/src/pages/RootPage').then(
            ({ RootPage }) => RootPage
        )
    ),
});
